import { IEntity, Entity } from "./Entity";
import { IUser } from "./User";

export interface IUserRole extends IEntity {
    UserID: number | null;
    RoleID: number | null;
    User?: IUser;
    Role?: IEntity;
}

export class UserRole extends Entity implements IUserRole {
    public UserID = null;
    public RoleID = null;
}